// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const surskit: PokeData = {
  "id": 283,
  "name": "surskit",
  "height": 5,
  "weight": 17,
  "base_experience": 54,
  "types": [
    PokeType.BUG,
    PokeType.WATER
  ],
  "api_moves": [
    "mist",
    "water-gun",
    "bubble-beam",
    "agility",
    "quick-attack",
    "haze",
    "bubble",
    "baton-pass",
    "sweet-scent",
    "water-sport",
    "aqua-jet",
    "soak",
    "sticky-web"
  ],
  "moves": [
    "bubble-beam",
    "quick-attack",
    "bubble",
    "aqua-jet",
    "sticky-web",
    "string-shot",
    "life-dew",
    "infest",
    "rain-dance",
    "brine",
    "water-spout",
    "bug-bite",
    "pounce"
  ],
  "evolution_chain": {
    "id": 141,
    "item": null,
    "species": [
      {
        "name": "surskit",
        "order": 309,
        "types": [
          PokeType.BUG,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "masquerain",
        "order": 310,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 283,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 41,
    "speed": 65,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
